import dynamic from 'next/dynamic';
import { memo } from 'react';
import { Box } from '@bridebook/ui';
import { MapSkeleton } from '@bridebook/web/components/search/search-desktop/skeletons/map-skeleton';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import { getSearchMarkers } from '@bridebook/web/app-basic/lib/search/selectors';
import { getIsMobile } from '@bridebook/web/app-basic/lib/app/selectors';
import componentStyles from './map-widget.style';
import { IMapWidget } from '@bridebook/toolbox/src/seo-facets/search-widgets';

interface IProps {
  widget: IMapWidget | null;
}

const Loading = () => <MapSkeleton />;

const GMap = dynamic(() => import('@bridebook/web/app-basic/components/g-map/g-map'), {
  loading: Loading,
  ssr: false,
});

const MapWidget = ({ widget }: IProps) => {
  const isMobile = useSelector(getIsMobile);
  const markers = useSelector(getSearchMarkers);

  const styles = componentStyles();

  if (!widget) {
    return null;
  }

  return (
    <Box style={styles.container}>
      {widget.title && (
        <Box as="h5" style={styles.title}>
          {widget.title}
        </Box>
      )}
      <GMap
        markers={markers}
        className="rounded-xl xl:rounded-[46px] xl:border-[5px] xl:border-space-15"
        height={isMobile ? 558 : 564}
      />
    </Box>
  );
};

export default memo(MapWidget);
